import XLRLogger from 'src/common/helpers/logger';
import { IDecodeData, IPrescriptionItem } from 'src/common/interfaces/dtos/IEwic';
import { eWicDecodePrescription } from './services/post-ewic-decode-prescription';

export interface EwicDecodePrescriptionDto {
  stateIdentifierCode: string;
  rawPsData: string;
}

export const processDecode = async (
  decodeData: EwicDecodePrescriptionDto,
): Promise<IDecodeData> => {
  return await eWicDecodePrescription(decodeData)
    .then(decodedItemList => {
      decodedItemList.prescriptionItems = decodedItemList.prescriptionItems.map(listItem => {
        const newItem: IPrescriptionItem = {
          ...listItem,
          unitOfMeasureApl: listItem['unitOfMeasureAplString'] || '',
        };
        delete newItem['unitOfMeasureAplString'];
        return newItem;
      });
      return decodedItemList;
    })
    .catch(error => {
      XLRLogger.error({
        message: 'Error retrieving full decode prescription details',
        source: 'ewic-decode-prescription',
        data: error,
      });
      throw error;
    });
};
